import { memo, ReactNode, useMemo } from "react";
import useLocalStorageState from "use-local-storage-state";
import { UserSettingContext, UserSettings } from "./UserSettingsContext";

export type UserSettingsLocalStorageProviderProps = {
  children: ReactNode | ReactNode[],
  settingKey?: string
}

export const UserSettingsLocalStorageProvider = memo<UserSettingsLocalStorageProviderProps>(({ children, settingKey = "mimicUserSettings" }) => {
  const [ settings, setSettings ] = useLocalStorageState(settingKey, {
    defaultValue: {},
  });

  const value = useMemo((): UserSettings => {
    return ({
      initialized: !!settings,
      saveSetting: (id: string, value: any) => {
        setSettings({
          ...(settings || {}),
          [id]: value,
        });
      },
      settings: settings || {},
    });
  }, [ settings, setSettings ]);

  return (
    <UserSettingContext.Provider value={value}>
      {children}
    </UserSettingContext.Provider>
  );
});